import { render, staticRenderFns } from "./MassDeletion.vue?vue&type=template&id=6106a3f1&scoped=true&"
import script from "./MassDeletion.vue?vue&type=script&lang=js&"
export * from "./MassDeletion.vue?vue&type=script&lang=js&"
import style0 from "./MassDeletion.vue?vue&type=style&index=0&id=6106a3f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106a3f1",
  null
  
)

export default component.exports